// extracted by mini-css-extract-plugin
export default {"container":"FZ-z","list":"GZ-z"};